module.exports = __webpack_public_path__ + "static/media/Check.9bbdd94b.svg";